import { render, staticRenderFns } from "./buyCompDC.vue?vue&type=template&id=12481a9a&scoped=true"
import script from "./buyCompDC.vue?vue&type=script&lang=js"
export * from "./buyCompDC.vue?vue&type=script&lang=js"
import style0 from "./buyCompDC.vue?vue&type=style&index=0&id=12481a9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12481a9a",
  null
  
)

export default component.exports